import { call, put, takeLatest } from "redux-saga/effects";

import { request } from "src/utils/api";
import { StatusCodes } from "http-status-codes";
import {
  fetchStatusReportFailure,
  fetchStatusReportSuccess,
} from "../slices/StatusReportSlice";
import { GET_STATUS_REPORT } from "../actions/StatusReportAction";
import notification from "antd/es/notification";

export function* fetchhStatusReportSaga(
  action: any
): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK)
      yield put(fetchStatusReportSuccess(result));
    else {
      yield put(fetchStatusReportFailure(result.message));
      notification.error({
        message: "Data Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(fetchStatusReportFailure(error.message));
  }
}
export default function* statusreportSaga() {
  yield takeLatest(GET_STATUS_REPORT, fetchhStatusReportSaga);
}
